class Slider {
	constructor() {
		this.hideSliderArrows();
		this.showSliderArrow();
	}

	hideSliderArrows() {
		$('.show-details').on('click', function () {
			$(this).closest('.flickity-carousel').find('.flickity-button').fadeOut(100);
		});
	}
	showSliderArrow() {
		$('.hide-details').on('click', function () {
			$(this).closest('.flickity-carousel').find('.flickity-button').fadeIn();
		});
	}
}

export default new Slider();